// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BAZAAR_SELLER_SHOW_OLDER = "Zobraz star\u0161ie";
export const BAZAAR_SELLER_SHOW_OLDER_THAN_3_MONTHS = "Zobraz aj star\u0161ie ako 3 mesiace";
export const BZ2_REVIEWS_FROM_BUYERS = "Od kupuj\u00facich";
export const BZ2_REVIEWS_FROM_SELLERS = "Od predajcov";
export const BZ2_SHOW_REVIEWS_FROM = "Zobrazi\u0165 hodnotenia:";
export const THE_SELLER_HAS_NO_REVIEWS = "Zatia\u013e \u017eiadne hodnotenia";
